<span class="sports-video"></span>
@if (showCountdown) {
    {{ sitecore.eSports.StreamingStarting }}
    <ms-count-down [until]="event.startDate" (end)="onCountdownEnded()" />
} @else {
    {{ sitecore.eSports.StreamingAvailable }}
}
